import * as React from "react";
import type { SVGProps } from "react";
const SvgMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#map_svg__a)">
      <path d="M3 21a.999.999 0 0 1-1-1V7c0-.38.21-.72.55-.89l6-3c.28-.14.61-.14.89 0l5.55 2.78 5.56-2.78c.31-.15.68-.14.97.04s.47.5.47.85v13c0 .38-.21.72-.55.89l-6 3c-.28.14-.61.14-.89 0L9 18.11l-5.55 2.78c-.14.07-.29.11-.45.11m6-5c.15 0 .31.04.45.11L15 18.89l5-2.5V5.62L15.45 7.9c-.28.14-.61.14-.89 0L9 5.12l-5 2.5v10.76l4.55-2.28c.14-.07.29-.11.45-.11z" />
      <path d="M9 18c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v13c0 .55-.45 1-1 1M15 21c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v13c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="map_svg__a">
        <path fill="#fff" d="M2 3h20v18H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMap;
